:host {
  --cta-font-size: 16px;
  --cta-line-height: 24px;
  --cta-link-transform: rotate(0deg);
  --cta-link-ml: 0;
  --cta-link-mb: @anchor-spacing;
  --cta-link-text-margin: 0 0 0 5px;
  --cta-link-text-height: 9px;
  --cta-link-text-width: 9px;
  --cta-link-padding: 0;
  --_cta-primary-padding: var(--cta-primary-padding, 0 10px);
  --_cta-secondary-border-color: var(--cta-secondary-border-color, #000);
  --_cta-secondary-background-color--hover: var(--cta-secondary-background-color--hover, var(--grey-80));
  --_cta-secondary-border-color--hover: var(--cta-secondary-border-color--hover, var(--grey-80));
  --_cta-secondary-text-color--hover: var(--cta-secondary-text-color--hover, #fff);
}

@cta-new-red: #FF4931;

.cta--right {
  margin-left: auto;
}

.cta--center {
  margin-left: auto;
  margin-right: auto;
}

.cta--left {
  margin-right: auto;
}

a {
  text-decoration: none;
}

h3 {
  display: inline-block;
  color: var(--black);
  font-size: 22px;
  line-height: 30px;
  .MatterMedium();
  margin-bottom: 5px;
}

.cta-wrapper:focus {
  outline: 2px solid var(--focus);
}

.cta-wrapper.primary,
.cta-wrapper.secondary,
.cta-wrapper.secondary--dark,
.cta-wrapper.secondary--dark-reskin,
.cta-wrapper.gradient,
.cta-wrapper.transparent--white,
.cta-wrapper.transparent--black {
  border: 1px solid;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 22px;
  margin-bottom: 20px;
  height: 46px;
  font-size: 16px;
  .MatterMedium();

  width: 46px;

  &:has(.cta__text) {
    width: 100%;
    max-width: 350px;
  }

  &:hover {
    text-decoration: none;
  }

  .cta__text {
    padding: var(--_cta-primary-padding);
  }
}

.cta-wrapper.tg-link .cta-anchor {
  color: @white;

  &:hover {
    color: @ig-red-650;
  }
}

.cta-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;

  .prefix,
  .suffix-wrapper {
    display: grid;
    place-items: center;
    width: 22px;
  }
}

.cta-wrapper.text-button {
  color: var(--black);
  width: fit-content;

  transition: color 300ms ease-in-out;

  .suffix-wrapper {
    transition: opacity 300ms ease-in-out;
  }

  &:hover {
    .suffix-wrapper {
      opacity: 0.5;
    }
  }

  &:active {
    color: var(--grey-50);

    .suffix-wrapper {
      opacity: 0.4;
    }
  }

  &:disabled {
    color: var(--grey-50);

    .suffix-wrapper {
      opacity: 0.4;
    }
  }
}

.cta-anchor.text-chevron {
  color: var(--black);
}

.cta-wrapper.text-chevron {
  color: var(--black);
  width: fit-content;

  .cta__text {
    display: none;

    @media (min-width: @medium-breakpoint) {
      display: block;
    }
  }

  &:disabled {
    color: var(--grey-50);

    .suffix-wrapper {
      opacity: 0.4;
    }
  }
}

.cta-wrapper.information {
  color: var(--black);
  background-color: transparent;
  border: 1px solid var(--grey-30);
  border-radius: var(--radius-sm);
  transition: background-color 300ms ease-in-out, border-color 300ms ease-in-out;
  max-width: 350px;
  font-weight: 600;
  padding: 16px;

  @media (min-width: @medium-breakpoint) {
    width: 100%;
  }

  .suffix-wrapper {
    justify-self: flex-end;
    color: var(--white);
    background-color: var(--red);
    height: 48px;
    width: 48px;
    border-radius: 999px;
    margin-left: auto;
    display: grid;
    place-items: center;

    .suffix {
      height: 22px;
    }
  }

  &:hover {
    background-color: var(--grey-10);
    border-color: var(--black);
  }

  &:active {
    background-color: var(--grey-20);
  }

  &:disabled {
    background-color: var(--grey-30);
  }

  &--new-red {
    .suffix-wrapper {
      background-color: @cta-new-red;
    }

    &:extend(.cta-wrapper.information all);
  }

}

.cta-anchor {

  &.link,
  &.link-arrow,
  &.secondary,
  &.link-button,
  &.left-facing-link-button,
  &.left-facing-link-button-red,
  &.secondary--dark-reskin {
    color: var(--cta-link-color, @ig-grey-900);
  }
}

.cta-wrapper:hover {
  cursor: pointer;
}

.cta-anchor.text-button {
  color: @black;

  &:hover {
    color: var(--grey-60);
  }
}

.cta-anchor.secondary-download,
.cta-anchor.information,
.cta-anchor.information--new-red,
.cta-anchor.transparent--black {
  color: @black;
}

.cta-anchor.primary,
.cta-anchor.secondary--dark,
.cta-anchor.secondary,
.cta-anchor.link-button--dark,
.cta-anchor.gradient,
.cta-anchor.transparent--white {
  color: @white;
}

.cta-anchor.gradient,
.cta-anchor.transparent--white,
.cta-anchor.transparent--black {
  font-weight: 600;
}

.cta-wrapper.primary {
  background-color: var(--red);
  border-color: var(--red);
  color: var(--white);
  transition: background-color 300ms ease-in-out, border-color 300ms ease-in-out;

  &:hover {
    background-color: var(--red-700);
    border-color: var(--red-700);
  }

  &:active {
    background-color: var(--red-800);
    border-color: var(--red-800);
  }
}

.cta-wrapper.secondary {
  background-color: var(--black);
  border-color: var(--_cta-secondary-border-color);
  color: var(--white);
  transition: background-color 300ms ease-in-out, border-color 300ms ease-in-out, color 300ms ease-in-out;

  &:hover {
    background-color: var(--_cta-secondary-background-color--hover);
    border-color: var(--_cta-secondary-border-color--hover);

    .cta__text {
      color: var(--_cta-secondary-text-color--hover);
    }
  }

  &:active {
    background-color: var(--grey-70);
  }
}

.cta-wrapper.secondary--dark-reskin {
  background-color: var(--white);
  color: var(--black);
  border-color: var(--grey-40);
  transition: background-color 300ms ease-in-out, border-color 300ms ease-in-out;

  &:hover {
    background-color: var(--grey-10);
    border-color: var(--black);
  }

  &:active {
    background-color: var(--grey-20);
  }

  &:disabled {
    background-color: var(--grey-30);
  }
}

.cta-wrapper.secondary--dark {
  background-color: transparent;
  border-color: var(--white);
  color: var(--white);
  transition: background-color 300ms ease-in-out, border-color 300ms ease-in-out;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-color: var(--white);
  }

  &:active {
    background-color: var(--grey-20);
  }

  &:disabled {
    background-color: var(--grey-30);
  }
}

.cta-wrapper.gradient {
  background: var(--gradient-orange-pink);
  border: none;
}

.cta-wrapper.transparent--white {
  background: transparent;
  border-color: var(--white);
  border-width: 2px;
}

.cta-wrapper.transparent--black {
  background: transparent;
  border-color: var(--black);
  border-width: 2px;
}

// Legacy styles
.cta-wrapper.link,
.cta-wrapper.link--dark,
.cta-wrapper.link-arrow,
.cta-wrapper.link-arrow--dark,
.cta-wrapper.link-button,
.cta-wrapper.link-button--dark {
  display: table;
  margin-bottom: var(--cta-link-mb, @anchor-spacing);
  padding: var(--cta-link-padding, 0);
  font-size: var(--cta-font-size, 16px);
  line-height: var(--cta-line-height, 24px);
  .MatterMedium();
  color: var(--black);

  .cta__text:not(:empty) {
    &>* {
      display: inline;
    }

    &::after {
      content: '';
      width: var(--cta-link-text-width, 9px);
      height: var(--cta-link-text-height, 9px);
      margin: var(--cta-link-text-margin, 0 0 0 5px);
      display: inline-block;
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="none"><path d="M3.838.903L4.898 0 9 3.871 4.897 8 3.838 6.968l2.25-2.323H0V3.097h6.088L3.838.903z" fill="%23E61E1E"/></svg>');
      background-repeat: no-repeat;
      transform: var(--cta-link-transform, rotate(0deg));
    }
  }
}

.cta-wrapper.link-button,
.cta-wrapper.link-button--dark {
  padding: 11px 29px;
  border-radius: 40px;
  border: 1px solid;
  font-weight: 600;
}

.cta-wrapper.link-button {
  background-color: var(--white);
  border-color: var(--black);
  color: var(--black);

  &:hover,
  &:focus {
    background-color: var(--grey-10);
  }
}

.cta-wrapper.link-button--dark {
  border-color: var(--white);
  color: var(--white);

  &:hover,
  &:focus {
    background-color: var(--grey-80);
  }
}

.cta-anchor.link:hover,
h3:hover {
  text-decoration: underline;
  color: var(--red);
}

.cta-anchor.link--dark,
.cta-anchor.link-arrow--dark,
.cta-anchor.link--dark h3 {
  color: var(--white);

  &:hover {
    color: var(--white);
    text-decoration: underline;
  }
}

.cta-wrapper.left-facing-link-button,
.cta-wrapper.left-facing-link-button-red {
  background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMjgzNzIgNEwxMC40IDUuMjY1MzhMNy4wNjk3NyA5LjAxOTMzTDE2IDkuMDE5MzNMMTYgMTEuMDAxOEw3LjA2OTc3IDExLjAwMThMMTAuMzgxNCAxNC43NTU3TDkuMjY1MTIgMTZMNCAxMC4wMTA1TDkuMjgzNzIgNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=') no-repeat,
    var(--white);
  background-position: 28px 13px;
  width: 100%;
  max-width: 280px;
  border: 1px solid var(--grey-40);
  border-radius: 40px;
  color: var(--black);
  font-weight: 600;
  padding: 13px 28px 13px 56px;
  position: relative;

  &:hover {
    background-color: var(--grey-10);
  }

  &.left-facing-link-button-red {
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMjgzNzIgNEwxMC40IDUuMjY1MzhMNy4wNjk3NyA5LjAxOTMzTDE2IDkuMDE5MzNMMTYgMTEuMDAxOEw3LjA2OTc3IDExLjAwMThMMTAuMzgxNCAxNC43NTU3TDkuMjY1MTIgMTZMNCAxMC4wMTA1TDkuMjgzNzIgNFoiIGZpbGw9IiNFMDFCMUMiLz4KPC9zdmc+Cg==');
    background-position: 28px 11px;
    border-color: var(--black);
    font-size: 16px;
  }
}

.cta-wrapper.secondary-download {
  display: table;
  color: var(--black);
  border: 1px solid var(--grey-30);
  border-radius: 40px;
  padding: 8px 20px 8px 0;
  font-weight: 600;
  font-size: var(--cta-font-size, 16px);
  line-height: var(--cta-line-height, 22px);

  &:hover {
    border-color: var(--black);
    background-color: var(--grey-10);
  }

  &:before {
    content: '';
    display: inline-block;
    width: 32px;
    height: 32px;
    background-image: url(data:image/svg+xml;base64,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);
    background-repeat: no-repeat;
    vertical-align: middle;
    margin: 0 12px 0 8px;
  }
}

@media (max-width: @medium-breakpoint) {
  .cta-wrapper {

    &.primary,
    &.secondary,
    &.secondary--dark,
    &.secondary--dark-reskin {
      width: 100%;
      max-width: 350px;
    }
  }

  &.link,
  &.link-button {
    margin-bottom: calc(var(--cta-link-mb, @anchor-spacing) - 10px);
  }

  &.secondary-download {
    width: 100%;
    max-width: 358px;
  }
}

.cta-color-variant(@modifier; @color-default; @color-hover) {
  .cta-wrapper.@{modifier} {
    background-color: @color-default;
    border-color: @color-default;
    color: var(--white);

    &:hover,
    &:active {
      background-color: @color-hover;
      border-color: @color-hover;
    }
  }

  .cta-anchor.@{modifier} {
    color: var(--white);
  }
}

.cta-color-variant(@modifier: secondary--new-red; @color-default: @cta-new-red; @color-hover: @black);